export default {
  name: 'ReviewsProfessional',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
